<!--
    Created by 杨莎莎 on 2025/08/11.
    Copyright © 2023年 云柜-金星晖. All rights reserved.
    界面名称：商户详情
    功能概述：
-->
<style lang="less">
.simplify-theme-dark {
  .merchant-detail {
    .under-bg {
      filter: brightness(60%) hue-rotate(332deg) blur(3px) !important;
    }
  }
}
.merchant-detail {
  position: relative;
  padding: 0 @containerGap @containerGap;
  border-radius: @borderRadiusMid;
  overflow: hidden;
  background-color: @backColorStrong;
  .under-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 80px;
    .display-flex();
    //justify-content: flex-end;
    //align-items: flex-end;
    overflow: hidden;
    filter: brightness(100%) hue-rotate(332deg) blur(3px);
    transform: rotateZ(180deg);
    transition: all @transitionTime15;
    opacity: 0.9;
    img {
      user-select: none;
      transition: all @transitionTime15;
    }
  }
  //头部
  .merchant-header {
    .display-flex();
    position: relative;
    color: @textColorStrong;
    //color: @textColorFlip;
    height: 80px;
    .header-center-box {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
      font-weight: 600;
      transition: all @transitionTime15;
      .h1 {
        padding-top: 5px;
        font-size: 20px;
        line-height: 20px;
      }
      .h2 {
        margin-top: 10px;
        font-size: 13px;
        line-height: 13px;
      }
    }
    .header-tab {
      .display-flex();
      padding: 0 5px;
      background-color: @backColorStrong;
      height: 40px;
      border-radius: 40px;
      .tab-item {
        padding: 0 8px;
        .display-flex();
        white-space: nowrap;
        font-size: 12px;
        height: 30px;
        border-radius: 30px;
        color: @textColorNormal;
        cursor: pointer;
        font-weight: 600;
        &.is-current {
          background-color: @themeColor;
          //color: @textColorStrong;
          color: @textColorFlip;
        }
        &+.tab-item {
          margin-left: 5px;
        }
      }
    }
  }
  .merchant-content {
    padding-top: @containerGap * 2;
    position: relative;
    transition: all @transitionTime25;
    .row-area {
      &+.row-area {
        margin-top: @containerGap * 2;
      }
      .h3 {
        position: relative;
        padding-left: 10px;
        margin-bottom: @containerGap;
        font-size: 18px;
        line-height: 18px;
        font-weight: 600;
        &::after {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 4px;
          border-radius: 2px;
          background-color: @themeColor
        }
      }
      .info-table {
        display: flex;
        flex-wrap: wrap;
        font-size: 13px;
        box-sizing: border-box;
        line-height: 17px;
        .info-table-row {
          padding: @containerGap * 0.5 0;
          .flex-grow(50%);
        }
        &.bank-table {
          &+.bank-table {
            margin-top: @containerGap * 0.5;
            padding-top: @containerGap * 0.5;
            border-top: 1px solid @lineColorLight;
          }
        }
      }
    }
  }
  &.show-info {
    .merchant-content.is-cash-content {
      opacity: 0;
      height: 0;
      padding: 0;
    }
  }
  &.show-cash {
    .under-bg {
      height: auto;
      filter: brightness(90%) hue-rotate(332deg) blur(3px);
      opacity: 1;
      img {
        width: 100%;
      }
    }
    .merchant-header {
      .header-center-box {
        opacity: 0;
      }
    }
    .merchant-content.is-info-content {
      opacity: 0;
      height: 0;
      padding: 0;
    }
    .merchant-content.is-cash-content {
      .display-flex();
      padding: 0 0 80px;
      .cash-card {
        height: 260px;
        width: 420px;
        border-radius: 20px;
        //background: rgba(255, 255, 255, 0.1);
        background: rgba(255, 255, 255, .1);
        //background: rgba(0, 0, 0, .1);
        backdrop-filter: blur(20px);
        border: 2px solid rgba(255, 255, 255, 0.1);
        box-shadow: 0 0 80px rgba(0, 0, 0, 0.25);
        padding: 30px 30px 30px 30px;
        overflow: hidden;
        color: white;
        .card-tit {
          line-height: 30px;
          height: 30px;
          font-size: 24px;
          font-weight: 600;
          text-shadow: 2px 2px 4px rgba(0,0,0,0.2);
        }
        .label {
          font-size: 15px;
          line-height: 18px;
          //text-shadow: 2px 2px 4px rgba(0,0,0,0.2);
        }
        .main-cash {
          margin-top: @containerGap * 1.5;
          .value {
            line-height: 42px;
            font-size: 30px;
            font-weight: 600;
            font-family: YgNumberFont;
            text-shadow: 2px 2px 4px rgba(0,0,0,0.2);
          }
          .main-acc-box {
            display: flex;
            align-items: flex-end;
            .can-get {
              margin-left: 5px;
              display: flex;
              align-items: center;
              line-height: 42px;
              font-size: 18px;
              font-weight: 300;
              .small-value {
                font-family: YgNumberFont;
                font-size: 22px;
              }
            }
          }
        }
        .adorn-cash {
          margin-top: @containerGap * 0.5;
          .display-flex();
          .cash-item {
            .display-flex();
            align-items: flex-end;
            .flex-grow(50%);
            .label {
              font-size: 13px;
              .flex-grow(82px);
              text-align: right;
            }
            .value {
              margin-left: 5px;
              flex: 1;
              font-size: 18px;
              line-height: 20px;
              font-family: YgNumberFont;
              &.can-click {
                text-decoration: underline;
                cursor: pointer;
                &:hover {
                  text-shadow: 2px 2px 4px rgba(0,0,0,0.2);
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>

<template>
  <yg-drawer
    :show-bottom="false"
    width="1000"
    :back-type="2"
    title="商户详情"
    @on-close="_close"
  >
    <div
      slot="content"
      class="merchant-detail"
      :class="tab.index === 0 ? 'show-info' : 'show-cash'"
    >
      <!--商户信息-->
      <div
        class="merchant-content is-info-content"
      >
        <!--信息-->
        <div
          v-for="(row, r) in infoItems"
          :key="'row-' + r"
          class="row-area"
        >
          <div class="h3">
            {{ row.title }}
          </div>
          <div
            v-if="!row.isBankList"
            class="info-table"
          >
            <div
              v-for="(item, i) in row.items"
              :key="i"
              class="info-table-row"
            >
              <yg-attribute-key-value
                :label="item.label"
                :label-width="100"
                :value="model[item.key]"
                :can-hide-phone="item.hidePhone"
                :can-copy="item.canCopy"
                :can-price="item.canPrice"
              />
            </div>
          </div>
          <div v-else>
            <div
              v-for="(bank, b) in model.merchantBankList"
              :key="'b-' + b"
              class="info-table bank-table"
            >
              <div
                v-for="(item, i) in row.items"
                :key="i"
                class="info-table-row"
              >
                <yg-attribute-key-value
                  :label="item.label"
                  :label-width="100"
                  :value="bank[item.key]"
                  :can-hide-phone="item.hidePhone"
                  :can-copy="item.canCopy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </yg-drawer>
</template>

<script>
// import vTakeOutList from '@/pages/bill/takeOutList/controller.vue';

export default {
  // components: { vTakeOutList },
  props: {
    model: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      tab: {
        // items: ['代理商户基本信息', '代理商户账户资金'],
        items: ['商户基本信息'],
        index: 0
      },
      infoItems: [
        {
          title: '商户基础信息',
          isBankList: false,
          items: [
            { label: '所属办事处：', key: 'officeName', canCopy: false, hidePhone: false }
          ]
        },
        {
          title: '开户信息',
          isBankList: false,
          items: [
            { label: '开户状态：', key: 'merchantStatusName', canCopy: false, hidePhone: false },
            { label: '商户编号：', key: 'merchantCode', canCopy: false, hidePhone: false },
            { label: '商家类型：', key: 'merchantTypeName', canCopy: false, hidePhone: false },
            { label: '证件类型：', key: 'idCardTypeName', canCopy: false, hidePhone: false },
            { label: '证件号码：', key: 'idCard', canCopy: true, hidePhone: false },
            { label: '商户名称：', key: 'merchantCompany', canCopy: false, hidePhone: false },
            { label: '开户银行：', key: 'bankName', canCopy: false, hidePhone: false },
            { label: '开户支行：', key: 'branchBank', canCopy: true, hidePhone: false },
            { label: '银行账号：', key: 'bankNo', canCopy: true, hidePhone: false },
            { label: '手机号码：', key: 'merchantTel', canCopy: false, hidePhone: true }
          ]
        },
        {
          title: '冻结金额及预警信息',
          isBankList: false,
          items: [
            { label: '冻结金额：', key: 'freezeAmount', canCopy: false, hidePhone: false, canPrice: true },
            { label: '预警金额：', key: 'warningAmount', canCopy: false, hidePhone: false, canPrice: true },
            { label: '预警手机号：', key: 'earlyWarningTels', canCopy: true, hidePhone: true }
          ]
        }
      ],
      showTakeOutListDialog: false
    };
  },
  created () {
    // console.log('详情', this.model);
  },
  methods: {
    _close () {
      this.$emit('on-close');
    },
    _clickPush (v) {
      if (v) {
        this.showTakeOutListDialog = true;
      }
    }
  }
};
</script>
